import React from "react"
import { getContent } from "components/Disclaimer/components/LanguageToggle"
import { Checkbox, Typography } from "@mui/material"
import { responsiveFontSize } from "style/style_snippets"
import { privacy_content } from "components/Disclaimer/content/content"

const privacyStyle = {
  box: {
    marginTop: 20,
    marginBottom: 20
  },
  ol: {
    paddingInlineStart: 20,
    "& > li": {
      fontSize: responsiveFontSize(18, 20),
      marginTop: 15
    },
    p: {
      marginTop: 10
    }
  },
  innerList: {
    li: {
      fontSize: "inherit !important",
      listStyleType: "lower-alpha"
    }
  },

  innerInnerList: {
    li: {
      fontSize: "inherit !important",
      listStyleType: "upper-roman"
    }
  }
}

const Privacy = ({ currentLanguage }) => {
  const contentLanguage = getContent({
    language: currentLanguage,
    content: privacy_content
  })

  const cookie = "mtm_consent_removed=";
  const [checked, setChecked] = React.useState(document.cookie.indexOf(cookie) < 0);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    const cookeIndex= document.cookie.indexOf(cookie);
    if ((cookeIndex >= 0)) {
      // remove cookie or reset to 0
      let cookiesFromMatomoCookie = document.cookie.substring(cookeIndex);
      let completeMatomoCookie = cookiesFromMatomoCookie.split(';')[0];

      let result = document.cookie.replace(completeMatomoCookie+";", "")
      if (document.cookie.indexOf(";") === -1 ){
        result = document.cookie.replace(completeMatomoCookie, cookie+"0");
      }
      document.cookie = result;
      window._paq.push(['setConsentGiven']);
    }
    else {
      // set cookie
      window._paq.push(['forgetConsentGiven']);
    }
  };

  return (
    <div css={privacyStyle}>
      <Typography variant={"h4"}>{contentLanguage.title}:</Typography>

      <div css={privacyStyle.box}>
        <Typography variant={"body1"}>{contentLanguage.mb}</Typography>
      </div>

      <div css={privacyStyle.box}>
        <Typography variant={"body1"}>Mercedesstraße 120</Typography>
        <Typography variant={"body1"}>D-70372 Stuttgart</Typography>
        <Typography variant={"body1"}>{contentLanguage.de}</Typography>
      </div>

      <div css={privacyStyle.box}>
        <Typography variant={"body1"}>
          E-Mail: <a href="mailto:foss@mercedes-benz.com">foss@mercedes-benz.com</a>
        </Typography>
      </div>

      <Typography variant={"h4"}>{contentLanguage.officer}</Typography>
      <div css={privacyStyle.box}>
        <Typography variant={"body1"}>Mercedes-Benz Group AG</Typography>
        <Typography variant={"body1"}>{contentLanguage.chief}</Typography>
        <Typography variant={"body1"}>HPC E600</Typography>
        <Typography variant={"body1"}>70546 Stuttgart</Typography>
        <Typography variant={"body1"}>{contentLanguage.de}</Typography>
      </div>

      <div css={privacyStyle.box}>
        <Typography variant={"body1"}>
          E-Mail:{" "}
          <a href="mailto:data.protection@mercedes-benz.com">
            data.protection@mercedes-benz.com
          </a>
        </Typography>
      </div>

      <ol>
        <li>
          <Typography variant={"h4"}>{contentLanguage.protection}</Typography>
        </li>
        <Typography variant={"body1"}>
          {contentLanguage.protection1}:
        </Typography>
        <Typography variant={"body1"}>
          <a
            target={"_blank"}
            rel={"noreferrer"}
            href="https://group.mercedes-benz.com/data-protection-policy"
          >
            {contentLanguage.protectionLink}
          </a>
        </Typography>
        <Typography variant={"body1"}>{contentLanguage.protection2}</Typography>

        <li>{contentLanguage.personalData}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.personalData1}
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.personalData2}
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.personalData3}
            </Typography>
          </li>
        </ol>

        <li>{contentLanguage.purposes}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.purposes1}
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.purposes2}
            </Typography>
          </li>
        </ol>

        <li>{contentLanguage.transfer}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.transfer1}
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.transfer2}
            </Typography>
          </li>
        </ol>

        <li>{contentLanguage.security}</li>
        <Typography variant={"body1"}>{contentLanguage.security1}</Typography>

        <li>{contentLanguage.bases}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>{contentLanguage.bases1}</Typography>
          </li>
          <li>
            <Typography variant={"body1"}>{contentLanguage.bases2}</Typography>
          </li>
          <li>
            <Typography variant={"body1"}>{contentLanguage.bases3}</Typography>
          </li>
          <li>
            <Typography variant={"body1"}>{contentLanguage.bases4}</Typography>
          </li>
        </ol>

        <li>{contentLanguage.deletion}</li>
        <Typography variant={"body1"}>{contentLanguage.deletion1}</Typography>

        <li>{contentLanguage.rights}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>{contentLanguage.rights1}</Typography>
          </li>
          <li>
            <Typography variant={"body1"}>{contentLanguage.rights2}</Typography>
          </li>
          <li
            style={{ border: "1px solid black", textDecoration: "underline" }}
          >
            <Typography variant={"body1"}>
              {contentLanguage.rights3_1}:
            </Typography>
            <Typography variant={"body1"}>
              {contentLanguage.rights3_2}:
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.rights4}:{" "}
              <a href="mailto:foss@mercedes-benz.com">foss@mercedes-benz.com</a>
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>{contentLanguage.rights5}</Typography>
          </li>
        </ol>

        <li>{contentLanguage.transmission}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.transmission1}
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.transmission2}
            </Typography>
          </li>
        </ol>

        {/*------*/}
        <li>{contentLanguage.cookies}</li>
        <ol css={privacyStyle.innerList}>
          <li>
            <Typography variant={"body1"}>
              {contentLanguage.cookies1}
            </Typography>
          </li>
        </ol>

        <li>{contentLanguage.tracking}</li>
        <div>
          <Typography variant={"body1"}>
            {contentLanguage.tracking1}
          </Typography>

          <Typography variant={"body1"}>
            {contentLanguage.tracking2}
          </Typography>

          <Typography variant={"body2"}>
            <Checkbox
            checked={checked}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />{contentLanguage.tracking3}
          </Typography>

          <Typography variant={"body1"}>
            {contentLanguage.tracking4}
          </Typography>

          <Typography variant={"body1"}>
            {contentLanguage.tracking5}
          </Typography>

        </div>
        {/*-----*/}
      </ol>

      <Typography variant={"body1"}>{contentLanguage.update}</Typography>
    </div>
  )
}

export default Privacy
